import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { IoIosCloudUpload } from "react-icons/io";
import { MdOutlineSaveAlt } from "react-icons/md";
import { RiEdit2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  createPatientCvAction,
  deletePatientCvAction,
  showPatientAciton,
  updatePatientInfoAction,
} from "../../../Actions/PatientActions/PatientAction";
import { useParams } from "react-router-dom";
import LoadingPage from "../../Loading/LoadingPage";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const ProfilePatient = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  function openModal(image) {
  const imageUrl = `${process.env.REACT_APP_IMAGE_API_URL}${image}`;
    setCurrentImage( imageUrl);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const { id: patientId } = useParams();
  const dispatch = useDispatch();
  const showPatient = useSelector((state) => state.showPatient);
  const { patients, loading } = showPatient;
  useEffect(() => {
    setState({
      ...state,
      patientInfoId: patients?.patient_info?.id,
      fullname: patients?.patient_info?.fullname,
      gender: patients?.patient_info?.gender,
      birthdate: patients?.patient_info?.birth_date,
      phone: patients?.patient_info?.phone,
    });
  }, [patients]);
  const [state, setState] = useState({
    fullname: "",
    phone: "",
    gender: "Male",
    birthdate: "",
    patientInfoId: "",
  });

  useEffect(() => {
    dispatch(showPatientAciton(patientId));
  }, []);

  const [image, setImage] = useState([]);
  const handleAdd = (e) => {
    e.preventDefault();
    setImage([...image, ""]);
  };

  const handleRemoveInput = (e, index) => {
    const removeInput = [...image];
    removeInput.splice(index, 1);
    setImage(removeInput);
  };
  const handleChangeFileImage = (e, index) => {
    const newValue = [...image];
    newValue[index] = e.target.files[0];
    setImage(newValue);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  const handleSubmit = () => {
    dispatch(
      updatePatientInfoAction(
        patientId,
        state.patientInfoId,
        state.fullname,
        state.phone,
        state.gender,
        state.birthdate
      )
    );
    if (image.length > 0) {
      dispatch(createPatientCvAction(patientId, image));
      setImage([]);
    }
  };

  const handleRemoveImage = (id) => {
    dispatch(deletePatientCvAction(id, patientId));
  };
  const imagePath=process.env;
  // console.log( " image path  : ",imagePath)
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="mt-3">
          <div className="head flex gap-2 items-center">
            Edit Patient <RiEdit2Fill />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div className="flex flex-col gap-2">
              <div>
                <label htmlFor="">Full Name *</label>
              </div>
              <div>
                <input
                  name="fullname"
                  value={state.fullname}
                  onChange={handleInputChange}
                  type="text"
                  className="input "
                  placeholder="Full Name"
                />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              {" "}
              <div>
                <label htmlFor="">Phone *</label>
              </div>
              <div>
                <input
                  name="phone"
                  value={state.phone}
                  onChange={handleInputChange}
                  type="text"
                  className="input "
                  placeholder="Full Name"
                />
              </div>
            </div>

            <div className="flex flex-col gap-2">
              {" "}
              <div>
                <label htmlFor="">Gender *</label>
              </div>
              <div>
                <select
                  name="gender"
                  onChange={handleInputChange}
                  value={state.gender}
                  className="input .5"
                  id=""
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              {" "}
              <div>
                <label htmlFor="">Birth Date *</label>
              </div>
              <div>
                <input
                  name="birthdate"
                  value={state.birthdate}
                  onChange={handleInputChange}
                  type="date"
                  className="input "
                  placeholder="Full Name"
                />
              </div>
            </div>
          </div>

          <div className="form-group w-full mt-2 ">
            <div onClick={handleAdd}>
              <button className="btn-green">
                <FaPlus />
              </button>
            </div>
            {image.map((img, index) => {
              return (
                <div
                  key={index}
                  className="flex items-center w-full px-4 m-auto "
                >
                  <label htmlFor={`doc-${index}`} className="inputFile">
                    <div className="file-container w-full">
                      <h4 className="text-base font-semibold text-center text-gray-700 w-full">
                        {img ? img.name : "Upload a file "}
                      </h4>
                      <div className="text-teal-600">
                        <IoIosCloudUpload />
                      </div>
                    </div>
                    <input
                      type="file"
                      id={`doc-${index}`}
                      // name="doc"
                      onChange={(e) => handleChangeFileImage(e, index)}
                      name={`image_${index}`}
                      hidden
                    />
                  </label>

                  <button
                    className="btn-danger py-2"
                    onClick={() => handleRemoveInput(index)}
                  >
                    <FaTrash />
                  </button>
                </div>
              );
            })}
          </div>
          <button
            onClick={handleSubmit}
            className="btn-teal mt-2 items-center justify-center"
          >
            Save <MdOutlineSaveAlt />
          </button>
          {/* {} */}
          <div className="grid grid-cols-4 gap-3 mt-2">
            {patients?.patient_cv?.map((cv, index) => (
              <div className="flex flex-col">
                
                <img
                  key={index}
                  className="w-full h-52 rounded-md border-2 border-black cursor-pointer"
                  src={`${process.env.REACT_APP_IMAGE_API_URL}${cv.path}`}
                  alt=""
                  onClick={() => openModal(cv.path)}
                />
                <div>
                  <button
                    onClick={() => handleRemoveImage(cv.id)}
                    className="btn-red  mt-3"
                  >
                    Remove Image <FaTrash />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Image Modal"
          >
            <div>
              <img
                className="
                 m-auto h-96  rounded-md"
                src={currentImage}
                alt=""
              />
              <button
                onClick={closeModal}
                className="mt-2 p-2 bg-red-500 text-white rounded-md"
              >
                Close
              </button>
            </div>
          </Modal>
        </div>
      )}
      <div className="pb-8"></div>
    </>
  );
};

export default ProfilePatient;
